import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = ({ compact = false, className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className={`awp-theme-toggle ${compact ? 'is-compact' : ''} ${className}`}
      onClick={() => toggleTheme()}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className="awp-theme-toggle__track">
        <span className={`awp-theme-toggle__thumb ${isDark ? 'is-dark' : ''}`}>
          {isDark ? <Moon size={12} /> : <Sun size={12} />}
        </span>
      </span>
      {!compact && (
        <span className="awp-theme-toggle__label">
          {isDark ? 'Dark' : 'Light'}
        </span>
      )}
    </button>
  );
};

export default ThemeToggle;
